const PROFILE_HYDRATION_EVENTS = new Set(['INITIAL_SESSION', 'SIGNED_IN']);

export const shouldHydrateProfileFromAuthEvent = (event, pathname) => (
  event === 'SIGNED_IN' || (
    pathname === '/auth/callback' && PROFILE_HYDRATION_EVENTS.has(event)
  )
);
